import AWS from 'aws-sdk';

/**
 * @ 
 */
export const {
  VITE_API_URL,
  VITE_AWS_S3_ACCESSKEYID,
  VITE_AWS_S3_SECRETACCESSKEY,
  VITE_AWS_S3_REGION,
  VITE_AWS_S3_SIGNATUREVERSION,
  VITE_AWS_S3_BUCKET
} = import.meta.env;
/**
 *  @abstract AWS INSTANCE
 * */
AWS.config.update({
    accessKeyId: VITE_AWS_S3_ACCESSKEYID,
    secretAccessKey: VITE_AWS_S3_SECRETACCESSKEY,
    region: VITE_AWS_S3_REGION,
    signatureVersion: VITE_AWS_S3_SIGNATUREVERSION,
  });
  
export const s3 = new AWS.S3();
  